import React from "react";
import Centralparttext from "./Centralparttext";
import Centralpartimages from "./Centralpartimages";

import "../../index.scss";
import "./Responsive.scss";
import "./Centralpart.scss";

const Centralpart = () => (
  <div className="central-part c-p-mg">
    <Centralpartimages />
    <div className="central-part">
      <Centralparttext />
    </div>
  </div>
);

export default Centralpart;
